import { FC, ReactNode } from 'react';
import styled from 'styled-components';
import { SettingsLabelWithoutMargin } from 'components/organisms/module-settings/styles';
import { useAntdRlUISwitcher } from 'contexts/antd-rlui-switcher';
import { HelperText01 } from 'ozone/atoms';

interface Props {
  label: ReactNode;
  descriptions?: string[];
  align?: boolean;
  children?: ReactNode;
  datacy?: string;
}

const Container = styled.div`
  display: flex;
`;

const Info = styled.div`
  flex: 0 0 200px;
  display: flex;
  flex-direction: column;
  align-items: stretch;
  margin-right: var(--layout-03);
`;

const Label = styled(SettingsLabelWithoutMargin)`
  padding: 0;
`;

const Description = styled(HelperText01)<{ $isNew?: boolean }>`
  padding: var(--layout-01) var(--layout-01) var(--layout-01) 0;
  color: ${({ $isNew }) => ($isNew ? 'var(--gray-70)' : undefined)};
`;

const Control = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: stretch;
  max-width: 60%;

  & > * {
    margin-bottom: var(--spacing-05);

    &:last-child {
      margin-bottom: 0;
    }
  }
`;

export const SettingsControlPanel: FC<Props> = ({
  label,
  descriptions = [],
  children,
  align,
  datacy,
}) => {
  const isNew = useAntdRlUISwitcher();

  return (
    <Container style={align ? { alignItems: 'center' } : {}}>
      <Info>
        <Label>{label}</Label>
        {descriptions.map((x) => (
          <Description key={x} $isNew={isNew}>
            {x}
          </Description>
        ))}
      </Info>
      <Control data-cy={datacy}>{children}</Control>
    </Container>
  );
};
